module.exports = __webpack_public_path__ + "static/367117_3_0-4571cdb2906967d6336a4a231e1b1e8e.ttf";